import React, { Suspense, useContext } from 'react'
import Joyride from 'react-joyride'
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from 'common/Layout/Nav'
import JoyrideContext from 'context/joyride/joyrideContext'
import useOrbitFlag from 'hooks/useOrbitFlag'
import {
  AccountManagement,
  AddAccount,
  BatchUpdate,
  BillingTable,
  BundleManagement,
  Changelog,
  CustomerSupportPage,
  Dashboard,
  DeliveryDetail,
  FaQuestions,
  GeneratePDF,
  NewOrder,
  OrderDetails,
  PermissionedRoute,
  ProductCatalogueMain,
  Profile,
  SimDetails,
  SimManagementPage,
  StoreFront,
  ViewAndUpdateAccount,
  ViewOrders,
  ViewQuotation
} from 'pages'
import BookingDeliveryMain from 'pages/Delivery/client/BookingDeliveryMain'
import TawkMsgr from 'services/TawkTo'

function ClientApp() {
  const { run, steps, stepIndex, callBack } = useContext(JoyrideContext)
  const FlagJoyride = useOrbitFlag('joyride')

  return (
    <>
      {FlagJoyride && (
        <Joyride
          continuous
          hideCloseButton
          showSkipButton
          disableScrollParentFix
          hideBackButton
          run={run}
          locale={{ last: 'Close' }}
          steps={steps}
          stepIndex={stepIndex}
          callback={callBack}
          styles={{
            options: {
              primaryColor: '#151D29',
              textColor: 'black'
            }
          }}
        />
      )}
      <TawkMsgr />
      <Suspense fallback={null}>
        <Routes>
          {/* BASE ROUTES */}
          <Route path='/' element={<Layout />}>
            <Route index element={<Navigate to='dashboard' />} />
            <Route path='dashboard' element={<Dashboard />} />
            <Route path='profile' element={<Profile />} />
            <Route path='changelog' element={<Changelog />} />
            <Route path='faq' element={<FaQuestions />} />
            {/* Reorg of sim management page */}
            <Route path='manage-sims'>
              <Route index element={<SimManagementPage />} />
              <Route path='batch-update' element={<BatchUpdate />} />
            </Route>
            <Route path='quotations'>
              <Route index element={<ViewQuotation />} />
            </Route>
            <Route path='shop'>
              <Route index element={<StoreFront />} />
              <Route
                path='product-catalogue'
                element={<ProductCatalogueMain />}
              />
            </Route>
            {/* TO DO: duplicated orders page */}
            <Route path='orders'>
              <Route index element={<ViewOrders />} />
            </Route>
            {/*TO DO: duplicated orders page*/}
            <Route path='order'>
              <Route index element={<ViewOrders />} />
              <Route path='new' element={<NewOrder />} />
              <Route path=':orderNo' element={<OrderDetails />} />
              <Route path=':orderNo/pdf' element={<GeneratePDF />} />

              <Route
                path='deliveryDetail/:orderNo'
                element={<DeliveryDetail />}
              />
            </Route>
            <Route path='edit-sim'>
              <Route index element={<SimDetails />} />
            </Route>
            <Route path='billing'>
              <Route index element={<BillingTable />} />
            </Route>
            <Route
              path='book-delivery/:orderNo'
              // element={<BookingDelivery />}
              element={<BookingDeliveryMain />}
            />
            <Route path='manage-bundle' element={<BundleManagement />} />
            <Route path='customer-support' element={<CustomerSupportPage />} />
            {/* ROOT ONLY ROUTES */}
            <Route element={<PermissionedRoute allowedRoles={['owner']} />}>
              <Route path='manage-accounts'>
                <Route index element={<AccountManagement />} />
                <Route path='add' element={<AddAccount />} />
                <Route path='view' element={<ViewAndUpdateAccount />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </>
  )
}

export default ClientApp
